export default "__VITE_ASSET__CMaRNfeV__"